<template>
  <div class="my-applications">
    <div class="page-header">
      <div class="title">
        <i class="el-icon-money"></i>
        <span>经理审核</span>
      </div>
    </div>

    <!-- 筛选查询区域 -->
    <div class="filter-section">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="ICCID">
          <el-input v-model="filterForm.iccid" placeholder="请输入ICCID" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="交易单号">
          <el-input v-model="filterForm.transactionNo" placeholder="请输入交易单号" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="交易类型">
          <el-select v-model="filterForm.transactionType" placeholder="请选择交易类型" style="width: 150px;">
            <el-option label="全部" value=""></el-option>
            <el-option label="充值订单" value="充值订单"></el-option>
            <el-option label="线上购买" value="线上购买"></el-option>
            <el-option label="支付宝" value="支付宝"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker
            v-model="filterForm.orderTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 240px;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="代理姓名">
          <el-input v-model="filterForm.agentName" placeholder="请输入代理姓名" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-download" @click="handleExport">导出</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-form :inline="true" :model="filterForm" class="filter-form">
       
      </el-form>
    </div>

    <!-- 审核弹窗 -->
    <el-dialog title="退款审核" :visible.sync="approvalDialogVisible" width="500px" :before-close="handleApprovalDialogClose">
      <div class="approval-dialog-content">
        <div class="approval-info">
          <p><span class="label">ICCID:</span> {{ currentApplication.iccid }}</p>
          <p><span class="label">交易单号:</span> <span class="transaction-no">{{ formatDisplayValue(currentApplication.transactionNo) }}</span></p>
          <p><span class="label">退款金额:</span> <span class="amount">{{ currentApplication.refundAmount }} 元</span></p>
        </div>
        
        <div class="approval-options">
          <el-radio-group v-model="approvalForm.status" @change="handleApprovalStatusChange">
            <el-radio :label="3">同意</el-radio>
            <el-radio :label="4">拒绝</el-radio>
          </el-radio-group>
        </div>
        
        <div class="approval-reason" v-if="approvalForm.status === 4">
          <el-form :model="approvalForm" ref="approvalForm" :rules="approvalRules">
            <el-form-item label="拒绝原因" prop="remark">
              <el-input type="textarea" v-model="approvalForm.remark" :rows="4" placeholder="请输入拒绝原因"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleApprovalDialogClose">取消</el-button>
        <el-button type="primary" @click="submitApproval" :loading="submitting">确认</el-button>
      </div>
    </el-dialog>

   <!-- 详情弹窗 -->
   <el-dialog title="详细信息" :visible.sync="detailDialogVisible" width="80%" :before-close="handleDialogClose">
      <div v-if="detailLoading" class="detail-loading">
        <el-skeleton :rows="10" animated />
      </div>
      <div v-else>
        <!-- 根据退款类型显示不同的组件 -->
        <wet-cat-pay v-if="currentRefundData && currentRefundData.rechargeType === '线上购买'" 
          :orderData="detailData"></wet-cat-pay>
        <div v-else class="refund-components">
          <prepaid-credit :records="addRecords" :orderData="detailData"></prepaid-credit>
          <consumption-amount :records="detailRecords" :orderData="detailData"></consumption-amount>
        </div>
       </div>
    </el-dialog>

    <!-- 图片预览弹窗 -->
    <el-dialog :visible.sync="imagePreviewVisible" append-to-body class="image-preview-dialog" :show-close="true" :modal="true" :close-on-click-modal="true" :close-on-press-escape="true">
      <img :src="previewImageUrl" class="preview-image" alt="预览图片">
    </el-dialog>

    <!-- 申请列表 -->
    <div class="application-list">
      <!-- 卡片形式展示申请列表 -->
      <div class="card-list">
        <!-- 单卡片布局 -->
        <div v-for="(item, index) in applicationList" :key="index" class="single-card-wrapper">
          <el-card class="application-card" shadow="hover">
            <div class="card-header">
              <div class="card-title">
                <span class="iccid-label">ICCID: </span>
                <span class="iccid-value">{{ item.iccid }}</span>
              </div>
              <div class="card-title">
                  <span class="iccid-label">交易单号:</span>
                  <span class="iccid-value">{{ formatDisplayValue(item.transactionNo) }}</span>
                </div>
              <el-tag :type="getStatusType(item.status)" size="small">审核状态：{{ item.statusText }}</el-tag>
            </div>
            
            <div class="card-content">
              <!-- 左侧支付截图区域 -->
              <div class="left-image-area">
                <div class="image-container">
                  <el-carousel height="220px" indicator-position="outside" arrow="always">
                    <el-carousel-item>
                      <img :src="item.paymentImage" alt="支付截图" class="payment-image" @click="previewImage(item.paymentImage)" />
                    </el-carousel-item>
                    <el-carousel-item v-if="item.refundScreenshot">
                      <img :src="'/api/api/v1/static/' + item.refundScreenshot" alt="退款截图" class="payment-image" @click="previewImage('/api/api/v1/static/' + item.refundScreenshot)" />
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
              
              <!-- 右侧信息区域 -->
              <div class="right-info-area">
               
                <div class="info-row">
                  <span class="info-label">来源渠道:</span>
                  <span class="info-value">{{ item.sourceChannel }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">接待人:</span>
                  <span class="info-value">{{ item.receptionist_name }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">接待日期:</span>
                  <span class="info-value">{{ item.receptionDate }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">所属团队:</span>
                  <span class="info-value">{{ item.team }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">代理等级:</span>
                  <span class="info-value">{{ item.agentLevel }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">支付时间:</span>
                  <span class="info-value">{{ item.transactionTime }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">可退金额:</span>
                  <span class="info-value amount">{{ item.refundableAmount }} 元</span>
                </div>
                <div class="info-row">
                  <span class="info-label">退款路径:</span>
                  <span class="info-value">{{ item.refundPath }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">退款人账号:</span>
                  <span class="info-value">{{ item.receivingAccount }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">退款单号:</span>
                  <span class="info-value">{{ item.refoundNo }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">退款金额:</span>
                  <span class="info-value amount">{{ item.refundAmount }} 元</span>
                </div>
                <div class="info-row">
                  <span class="info-label">退款类型:</span>
                  <span class="info-value">{{ item.rechargeType }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">退款申请人:</span>
                  <span class="info-value">{{ formatDisplayValue(item.applicant) }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">套餐退订:</span>
                  <span class="info-value">{{ item.isPackageUnsubscribed }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">套餐退订人:</span>
                  <span class="info-value">{{ item.packageUnsubscriber }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">套餐退订时间:</span>
                  <span class="info-value">{{ item.packageUnsubscribeTime }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">佣金是否回溯:</span>
                  <span class="info-value">{{ item.isCommissionTracedBack }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">佣金回溯时间:</span>
                  <span class="info-value">{{ item.commissionTracebackTime }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">佣金回溯操作人:</span>
                  <span class="info-value">{{ item.commissionTracebackOperator }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">主管审核状态:</span>
                  <span class="info-value">{{ getApproveStatusText(item.supervisorApproveStatus) }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">主管审核人:</span>
                  <span class="info-value">{{ item.supervisorApprover }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">主管审核备注:</span>
                  <span class="info-value">{{ formatApproveRemark(item.supervisorApproveStatus, item.supervisorApproveRemark) }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">主管审核时间:</span>
                  <span class="info-value">{{ item.directorApprovalTime }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">经理审核状态:</span>
                  <span class="info-value">{{ getApproveStatusText(item.managerApproveStatus) }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">经理审核人:</span>
                  <span class="info-value">{{ item.managerApprover }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">经理审核备注:</span>
                  <span class="info-value">{{ formatApproveRemark(item.managerApproveStatus, item.managerApproveRemark) }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">经理审核时间:</span>
                  <span class="info-value">{{ item.managerApprovalTime }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">财务审核状态:</span>
                  <span class="info-value">{{ getApproveStatusText(item.financeApproveStatus) }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">财务审核人:</span>
                  <span class="info-value">{{ item.financeApprover }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">财务审核备注:</span>
                  <span class="info-value">{{ formatApproveRemark(item.financeApproveStatus, item.financeApproveRemark) }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">财务审核时间:</span>
                  <span class="info-value">{{ item.financeApprovalTime }}</span>
                </div>
                <div class="info-row notes-row">
                  <span class="info-label">退款原因:</span>
                  <span class="info-value">{{ item.notes }}</span>
                  <div class="action-buttons">
                    <el-button style="background-color: #f56c6c; border-color: 
                    #f56c6c; color: #ffffff;" size="small" @click="handleSubmitApproval(item)" 
                    class="action-button"   v-if="item.supervisorApproveStatus === 0 || item.statusText === '待经理审批'">审核</el-button>
                    <el-button style="background-color: #409EFF; border-color: #409EFF;
                     color: #ffffff;" size="small" @click="viewDetail(item)" class="action-button">查看详情</el-button>
                  </div>

                </div>
              </div>
            </div>
           </el-card>
        </div>
      </div>

      <!-- 操作按钮区域 -->
  

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getDictData } from '@/api/dict'
import request from '@/utils/request'
import PrepaidCredit from '@/components/prepaidcredit/prepaidcredit.vue'
import ConsumptionAmount from '@/components/consumption/consumptionAmount.vue'
import WetCatPay from '@/views/refund/wetCatPay/wetCatPay.vue'

export default {
  name: 'MyApplications',
  components: {
    PrepaidCredit,
    ConsumptionAmount,
    WetCatPay
  },
  data() {
    return {
      filterForm: {
        dateRange: [],
        transactionDateRange: [],
        approvalNo: '',
        transactionNo: '',
        status: '',
        iccid: '',
        transactionType: '',
        orderTimeRange: [],
        agentName: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      applicationList: [],
      sourceChannelList: [],
      detailDialogVisible: false,
      activeTab: 'prepaid',
      
      // 新增审核相关数据
      approvalDialogVisible: false,
      currentApplication: {},
      approvalForm: {
        status: 3, // 默认同意
        remark: ''
      },
      approvalRules: {
        remark: [
          { required: true, message: '请输入拒绝原因', trigger: 'blur' },
          { min: 5, max: 200, message: '长度在 5 到 200 个字符', trigger: 'blur' }
        ]
      },
      submitting: false,
      imagePreviewVisible: false,
      previewImageUrl: '',
      // 添加查看详情相关数据
      currentRefundData: null,
      detailData: {},
      detailRecords: [],
      addRecords: [],
      detailLoading: false
    }
  },
  created() {
    this.loadConfig().then(() => {
      this.fetchApplicationList()
    })
  },
  methods: {
    async loadConfig() {
      try {
        this.sourceChannelList = await getDictData('KFTSLY') // 来源渠道
        console.log('加载来源渠道字典数据:', this.sourceChannelList)
      } catch (error) {
        console.error('加载配置失败', error)
      }
    },
    fetchApplicationList() {
      // 显示加载状态
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      // 准备请求参数
      const params = {
        page: this.pagination.currentPage,
        size: this.pagination.pageSize
      }

      // 添加日期范围过滤条件
      if (this.filterForm.orderTimeRange && this.filterForm.orderTimeRange.length === 2) {
        params.reception_date_start = this.filterForm.orderTimeRange[0]
        params.reception_date_end = this.filterForm.orderTimeRange[1]
      }

      // 添加其他过滤条件
      if (this.filterForm.iccid) {
        params.card_no = this.filterForm.iccid
      }

      if (this.filterForm.transactionNo) {
        params.apply_no = this.filterForm.transactionNo
      }

      if (this.filterForm.agentName) {
        params.receptionist_name = this.filterForm.agentName
      }

      if (this.filterForm.transactionType) {
        params.refund_type = this.filterForm.transactionType === '充值订单' ? 1 : 2
      }

      // 发送请求获取数据
      request({
        url: '/api/v1/kf-refound/list-by-manager',
        method: 'POST',
        data: params
      }).then(response => {
        // 关闭加载状态
        loading.close()

        console.log('API响应原始数据:', response)

        if (response && response.status === 1) {
          // 设置分页总数
          this.pagination.total = response.total || 0
          
          // 映射API返回的数据到前端需要的格式
          this.applicationList = response.data.map(item => {
           // 处理图片URL，确保完整路径
           let paymentImageUrl = item.payment_screenshot || ''
         
         paymentImageUrl='/api/api/v1/static/'+paymentImageUrl
         
            
            console.log('处理单条数据:', item)
            
            const mappedItem = {
              id: item.id,
              approvalNo: item.apply_no,
              transactionNo: item.payment_order_no || item.apply_no, // 优先使用支付单号作为交易单号，而不是申请编号
              registerDate: this.formatDateTime(item.reception_date),
              sourceChannel: this.getSourceChannelName(item.source_channel),
              sourceChannelCode: item.source_channel,
              refundableAmount: item.refundable_amount || 0,
              status: this.mapStatusToFrontend(item.status),
              statusText: item.status_text || this.getStatusText(item.status),
              iccid: item.card_no || '',
              transactionType: item.refund_type === 1 ? '线上购买' : '充值订单',
              orderTime: this.formatDate(item.payment_time) || this.formatDate(item.reception_date),
              agentName: item.receptionist_name || '未知',
              receptionDate: this.formatDate(item.reception_date),
              team: item.team || '',
              teamId: item.team_id || '',
              refundPath: item.refund_path || '原路退回',
              applicant: this.formatApplicantName(item.applicant),
              receivingAccount: item.refund_channel || '收款账号',
              notes: item.refund_reason || '',
              paymentImage: paymentImageUrl,
              receptionist_id: item.receptionist_id || '',
              receptionist_name: item.receptionist_name || '',
              managerApprovalTime: item.manager_approve_time ? this.formatDateTime(item.manager_approve_time) : '暂无',
              financeApprovalTime: item.finance_approve_time ? this.formatDateTime(item.finance_approve_time) : '暂无',
              directorApprovalTime: item.supervisor_approve_time ? this.formatDateTime(item.supervisor_approve_time) : '暂无',
              supervisorApprover: item.supervisor_name || '暂无',
              supervisorApproveStatus: item.supervisor_approve_status ,
              supervisorApproveRemark: item.supervisor_approve_remark || '',
              managerApprover: item.manager_name || '暂无',
              managerApproveStatus: item.manager_approve_status ,
              managerApproveRemark: item.manager_approve_remark || '',
              financeApprover: item.finance_name || '暂无',
              financeApproveStatus: item.finance_approve_status ,
              financeApproveRemark: item.finance_approve_remark || '',
              refundDate: item.refund_date ? this.formatDate(item.refund_date) : '暂无',
              refundScreenshot: item.refund_screenshot || '',
              refoundNo: item.refound_no || '暂无',
              refundAmount: item.refund_amount || '暂无',
              // 添加卡片展示需要的其他属性
              cardCompany: '移动',
              cardSource: '官网',
              rechargeType: item.refund_type === 1 ? '线上购买' : '充值订单',
              thirdPartyNumber: item.third_party_number || '',
              cashback: '50 元',
              unreturnedAmount: '0 元',
              costPrice: '300 元',
              quantity: '1',
              transactionTime: this.formatDateTime(item.payment_time) || '',
              agentLevel: item.agent_level || '',
              packageUnsubscriber: item.unsubscriber_name || '暂无',
              packageUnsubscribeTime: item.package_unsubscribe_time ? this.formatDateTime(item.package_unsubscribe_time) : '暂无',
              isPackageUnsubscribed: item.is_package_unsubscribed ? '是' : '否',
              commissionTracebackTime: item.commission_traceback_time ? this.formatDateTime(item.commission_traceback_time) : '暂无',
              commissionTracebackOperator: item.traceback_operator_name || '暂无',
              isCommissionTracedBack: item.is_commission_traced_back ? '是' : '否',
              my_order_number: item.my_order_number || ''
            }
            
            console.log('映射后的数据:', mappedItem)
            return mappedItem
          })
          
          console.log('处理后的申请列表:', this.applicationList)
        } else {
          this.$message.error(response?.msg || '获取申请列表失败')
          this.applicationList = []
          this.pagination.total = 0
        }
      }).catch(error => {
        loading.close()
        console.error('获取申请列表出错:', error)
        this.$message.error('获取申请列表失败: ' + (error.message || '未知错误'))
        this.applicationList = []
        this.pagination.total = 0
      })
    },
    
    handleSearch() {
      // 在实际应用中，这里应该根据筛选条件调用API
      console.log('搜索条件:', {
        iccid: this.filterForm.iccid,
        transactionNo: this.filterForm.transactionNo,
        transactionType: this.filterForm.transactionType,
        orderTimeRange: this.filterForm.orderTimeRange,
        agentName: this.filterForm.agentName
      })
      this.pagination.currentPage = 1
      this.fetchApplicationList()
    },
    handleReset() {
      this.filterForm = {
        dateRange: [],
        transactionDateRange: [],
        approvalNo: '',
        transactionNo: '',
        status: '',
        iccid: '',
        transactionType: '',
        orderTimeRange: [],
        agentName: ''
      }
      this.fetchApplicationList()
    },
    handleExport() {
      this.$message.success('导出功能开发中')
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchApplicationList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchApplicationList()
    },
    viewDetail(row) {
      // 显示详情弹窗
      this.detailDialogVisible = true,
      // 设置当前查看的退款数据
      this.currentRefundData = row,
      // 获取退款详情数据
      this.fetchRefundDetail(row)
    },
    // 获取退款详情数据
    fetchRefundDetail(row) {
      // 显示加载状态
      this.detailLoading = true
      console.log(row)
      // 发送请求获取退款详情数据
      request({
        url: '/api/v1/kf-refound/get-by-order-number',
        method: 'POST',
        data: { orderNumber: row.transactionNo, my_order_number: row.my_order_number }
      }).then(response => {
        // 关闭加载状态 
        this.detailLoading = false
       if(response && response.status === 1){
        // 更新详情数据
        this.detailData = response.data || {}
        this.detailRecords = response.data.records || []
        // 筛选充值记录
        if (this.detailRecords && this.detailRecords.length > 0) {
          // 根据API返回的数据结构，识别增加类型记录
          this.addRecords = this.detailRecords.filter(record => {
            // 根据数据结构，判断是否为增加类型记录
            return record.record_type === '增加' || 
            (record.op_money === 100 && record.record_source === 5);
          });
        } else {
          this.addRecords = [];
        }
       }else {
          this.$message.error(response?.msg || '获取退款详情失败')
        }
      }).catch(error => {
        this.detailLoading = false
        console.error('获取退款详情出错:', error)
        this.$message.error('获取退款详情失败: ' + (error.message || '未知错误'))
      })
    },

    handleEdit(row) {
      this.$router.push({
        path: '/refund/requestRefund',
        query: {
          id: row.id
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该申请记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 显示加载状态
        const loading = this.$loading({
          lock: true,
          text: '删除中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 发送删除请求
        request({
          url: '/api/v1/kf-refound/delete',
          method: 'POST',
          data: { id: row.id }
        }).then(response => {
          // 关闭加载状态
          loading.close()

          if (response && response.status === 1) {
            this.$message.success('删除成功')
            // 重新获取列表数据
            this.fetchApplicationList()
          } else {
            this.$message.error(response?.msg || '删除失败')
          }
        }).catch(error => {
          loading.close()
          console.error('删除申请出错:', error)
          this.$message.error('删除失败: ' + (error.message || '未知错误'))
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    getStatusType(status) {
      const statusMap = {
        draft: 'info',
        reviewing: 'warning',
        approved: 'success',
        rejected: 'danger'
      }
      return statusMap[status] || 'info'
    },
    handleDialogClose() {
      this.detailDialogVisible = false
    },
    handleSubmitApproval(item) {
      this.currentApplication = item;
      this.approvalForm = {
        status: 3, // 默认同意
        remark: ''
      };
      this.approvalDialogVisible = true;
    },
    handleApprovalStatusChange(value) {
      console.log('审核状态变更:', value, value === 3 ? '同意' : '拒绝');
      if (value === 3) {
        this.approvalForm.remark = '';
      }
    },
    handleApprovalDialogClose() {
      this.approvalDialogVisible = false;
    },
    submitApproval() {
      console.log('提交审核, 当前状态:', this.approvalForm.status, this.approvalForm.status === 3 ? '同意' : '拒绝');
      
      // 如果是拒绝状态，需要验证表单
      if (this.approvalForm.status === 4) {
        this.$refs.approvalForm.validate(valid => {
          if (!valid) {
            return;
          }
          this.doSubmitApproval();
        });
      } else {
        this.doSubmitApproval();
      }
    },
    doSubmitApproval() {
      const id = this.currentApplication.id;
      
      if (!id) {
        this.$message.error('未找到申请记录');
        return;
      }
      
      this.submitting = true;
      
      // 显示加载状态
      const loading = this.$loading({
        lock: true,
        text: '提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      
      // 将前端状态码转换为API需要的状态码
      // 前端：3-同意，4-拒绝
      // API：1-同意，2-拒绝
      const apiStatus = this.approvalForm.status === 3 ? 1 : 2;
      
      console.log('审核提交参数:', {
        id: id,
        status: apiStatus,
        remark: this.approvalForm.remark || '',
        frontendStatus: this.approvalForm.status,
        statusText: this.approvalForm.status === 3 ? '同意' : '拒绝'
      });
      
      // 发送审核请求
      request({
        url: '/api/v1/kf-refound/manager-approve',
        method: 'POST',
        data: {
          "id": id,
          "status": apiStatus,
          "remark": this.approvalForm.remark || ''
        }
      }).then(response => {
        // 关闭加载状态
        loading.close();
        this.submitting = false;
        
        console.log('审核响应:', response);
        
        if (response && response.status === 1) {
          const successMsg = apiStatus === 1 ? '已同意退款申请' : '已拒绝退款申请';
          this.$message.success(response.msg || successMsg);
          this.approvalDialogVisible = false;
          
          // 延迟一下再刷新列表，确保服务器状态已更新
          setTimeout(() => {
            this.fetchApplicationList();
          }, 500);
        } else {
          this.$message.error(response?.msg || '审核操作失败');
          console.error('审核失败:', response);
        }
      }).catch(error => {
        loading.close();
        this.submitting = false;
        console.error('审核操作出错:', error);
        this.$message.error('审核操作失败: ' + (error.message || '未知错误'));
      });
    },
    // 批量操作方法
    handleBatchSubmitApproval() {
      this.$message.info('批量提交审核功能开发中')
    },
    handleBatchEdit() {
      this.$message.info('批量编辑功能开发中')
    },
    handleBatchViewDetail() {
      this.$message.info('批量查看详情功能开发中')
    },


       // 格式化审核备注
       formatApproveRemark(status, remark) {
      if (status === 1) {
        return '同意';
      } else if (status === 2 && remark) {
        return remark;
      } else {
        return '暂无';
      }
    },
    // 格式化日期时间
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return ''
      try {
        const date = new Date(dateTimeStr)
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        }).replace(/\//g, '-')
      } catch (e) {
        return dateTimeStr
      }
    },
    
    // 格式化日期
    formatDate(dateTimeStr) {
      if (!dateTimeStr) return ''
      try {
        const date = new Date(dateTimeStr)
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        }).replace(/\//g, '-')
      } catch (e) {
        return dateTimeStr
      }
    },
    
    // 将API状态映射到前端状态
    mapStatusToFrontend(status) {
      const statusMap = {
        1: 'draft',      // 待提交 -> 草稿
        2: 'reviewing',  // 审核中
        3: 'approved',   // 已通过
        4: 'rejected'    // 已拒绝
      }
      return statusMap[status] || 'draft'
    },
    
    // 获取来源渠道名称
    getSourceChannelName(code) {
      // 查找对应的来源渠道名称
      if (this.sourceChannelList && this.sourceChannelList.length > 0) {
        const channel = this.sourceChannelList.find(item => item.itemValue === code);
        if (channel) {
          return channel.itemLabel;
        }
      }
      
      // 如果在字典中找不到，直接返回code
      return code || '未知';
    },
    
    // 获取状态文本
    getStatusText(status) {
      const statusTextMap = {
        1: '待提交',
        2: '审核中',
        3: '已通过',
        4: '已拒绝'
      }
      return statusTextMap[status] || '待提交'
    },
    getApproveStatusText(status) {
      const statusTextMap = {
        0: '待审核',
        1: '已通过',
        2: '已拒绝',
      }
      console.log('审核状态码:', status, '对应文本:', statusTextMap[status] || '待审核');
      return statusTextMap[status] || '待审核'
    },
    // 格式化显示值，避免UUID格式的乱码
    formatDisplayValue(value) {
      if (!value) return '暂无';
      
       // 如果是退款申请人字段，尝试解析JSON
       try {
        const obj = JSON.parse(value);
        if (obj && obj.name) {
          return obj.name;
        }
      } catch (e) {
        // 不是JSON格式，继续处理
      }
      
      // 直接返回完整值，不再截断
      return value;
    },
    
    // 格式化退款申请人名称
    formatApplicantName(applicant) {
      if (!applicant) return '暂无';
      
      // 尝试解析JSON
      try {
        const obj = JSON.parse(applicant);
        if (obj && obj.name) {
          return obj.name;
        }
      } catch (e) {
        // 不是JSON格式，继续处理
      }
      
      // 直接返回原始值，不再随机生成名字
      return applicant;
    },
    previewImage(imageUrl) {
      this.previewImageUrl = imageUrl;
      this.imagePreviewVisible = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.my-applications {
  padding: 20px;
  background-color: #fff;
  min-height: 100vh;

  .page-header {
    margin-bottom: 20px;
   
    .title {
      font-size: 16px;
      font-weight: 500;
      display: flex;
      align-items: center;
   
      i {
        margin-right: 8px;
        color: #409EFF;
      }
    }
  }

  .filter-section {
    background-color: #fff;
    padding: 25px;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .filter-form {
      margin-bottom: 20px;
      
      .el-form-item {
        margin-right: 25px;
        margin-bottom: 15px;
      }
    }
  }

  .application-list {
    background-color: #fff;
    border-radius: 4px;
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .card-list {
      margin-bottom: 20px;
      
      .single-card-wrapper {
        margin-bottom: 20px;
      }
      
      .application-card {
        transition: all 0.3s;
        background-color: #f0f7ff;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
        
        &:hover {
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
          transform: translateY(-3px);
        }
        
        .card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          border-bottom: 1px solid #c9d8f0;
          padding: 15px 20px;
          background-color: #d4e4f7;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          
          .card-title {
            font-weight: bold;
            font-size: 16px;
            
            .iccid-label {
              color: #3a5d99;
            }
            
            .iccid-value {
              color: #303133;
              font-weight: 600;
            }
          }
        }
        
        .card-content {
          margin-bottom: 15px;
          padding: 15px 20px;
          display: flex;
          
          .left-image-area {
            width: 200px;
            margin-right: 20px;
            border: 1px solid #c9d8f0;
            border-radius: 8px;
            padding: 12px;
            background-color: #f9fbff;
            display: flex;
            flex-direction: column;
            height: 240px;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
            
            .image-container {
              border: 1px solid #d4e4f7;
              border-radius: 6px;
              overflow: hidden;
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #f5f7fa;
              position: relative;
              
              :deep(.el-carousel) {
                width: 100%;
                height: 100%;
                
                .el-carousel__container {
                  height: 100%;
                }
                
                .el-carousel__arrow {
                  background-color: rgba(31, 45, 61, 0.5);
                  
                  &:hover {
                    background-color: rgba(31, 45, 61, 0.8);
                  }
                }
                
                .el-carousel__indicators {
                  bottom: 0;
                }
              }
              
              .payment-image {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                cursor: zoom-in;
              }
            }
          }
          
          .right-info-area {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            max-height: 400px;
            overflow-y: auto;
            
            .info-row {
              display: flex;
              margin-bottom: 12px;
              width: 25%;
              padding-right: 15px;
              box-sizing: border-box;
              flex-direction: row;
              align-items: center;
              
              .info-label {
                color: #5a7db5;
                width: auto;
                flex-shrink: 0;
                text-align: left;
                margin-right: 8px;
                white-space: nowrap;
                font-size: 14px;
                font-weight: 500;
              }
              
              .info-value {
                color: #2c3e50;
                flex: 1;
                font-weight: 500;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 14px;
                
                &.transaction-no {
                  white-space: normal;
                  word-break: break-all;
                  overflow: visible;
                }
                
                &.amount {
                  color: #f56c6c;
                  font-weight: bold;
                }
              }
              
              &.notes-row {
                width: 100%;
                margin-top: 15px;
                border-top: 1px dashed #c9d8f0;
                padding-top: 15px;
                position: relative;
                
                .action-buttons {
                  position: absolute;
                  right: 0;
                  top: 15px;
                  
                  .action-button {
                    margin-left: 8px;
                    font-size: 13px;
                    padding: 8px 12px;
                    border-radius: 4px;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    transition: all 0.3s;
                    
                    &:hover {
                      transform: translateY(-2px);
                      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
                    }
                  }
                }
              }
            }
          }
        }
        
        .detail-button-container {
          text-align: right;
          border-top: 1px solid #c9d8f0;
          padding: 10px 15px;
          background-color: #f9fbff;
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
          
          .el-button {
            padding: 8px 15px;
            margin-left: 10px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
            
            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
              opacity: 0.9;
            }
          }
        }
      }
    }

    .action-buttons-container {
      margin-bottom: 20px;
      text-align: right;
    }

    .pagination {
      margin-top: 25px;
      text-align: right;
      padding: 10px 0;
      
      :deep(.el-pagination) {
        padding: 0;
        font-weight: normal;
        
        .el-pagination__total,
        .el-pagination__sizes,
        .el-pagination__jump {
          margin-right: 15px;
        }
        
        .btn-prev,
        .btn-next,
        .el-pager li {
          background-color: #f0f7ff;
          border: 1px solid #d4e4f7;
          color: #5a7db5;
          
          &:hover {
            color: #409EFF;
          }
          
          &.active {
            background-color: #409EFF;
            color: #fff;
            border-color: #409EFF;
          }
        }
      }
    }
  }

  :deep(.el-table th) {
    background-color: #b4c6e9!important;
  } 
  
  :deep(.el-table td) {
    background-color: #e8f1fc!important;
  }
  
  // 审核弹窗样式
  .approval-dialog-content {
    padding: 10px 0;
    
    .approval-info {
      margin-bottom: 20px;
      padding: 15px;
      background-color: #f0f7ff;
      border-radius: 6px;
      
      p {
        margin: 8px 0;
        font-size: 14px;
        
        .label {
          display: inline-block;
          width: 80px;
          color: #5a7db5;
          font-weight: 500;
        }
        
        .amount {
          color: #f56c6c;
          font-weight: bold;
        }
      }
    }
    
    .approval-options {
      margin-bottom: 20px;
      padding: 0 15px;
    }
    
    .approval-reason {
      margin-top: 15px;
    }
  }
  
  .dialog-footer {
    text-align: right;
  }

  // 图片预览弹窗样式
  .image-preview-dialog {
    :deep(.el-dialog) {
      margin-top: 5vh !important;
      max-width: 90%;
      max-height: 90vh;
      
      .el-dialog__header {
        padding: 10px;
        text-align: right;
      }
      
      .el-dialog__body {
        padding: 0;
        background-color: #000;
      }
    }
    
    .preview-image {
      width: 100%;
      max-height: 80vh;
      object-fit: contain;
      cursor: zoom-out;
    }
     // 详情弹窗加载状态样式
  .detail-loading {
    padding: 20px;
    text-align: center;
  }

  // 详情弹窗组件容器样式
  .refund-components {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  }
}
</style> 